<!DOCTYPE html>
<!--footer-->
<footer class="bg-dark mt-4 text-white">
  <div class="container pt-4">
    <div class="row">
      <div class="col-sm">
        <!-- Section: Social media -->
        <section class="h-100">
          <!-- <div class="row"> -->
          <div class="row d-flex justify-content-center">
            <!--Grid column-->
            <div class="col-auto">
              <p class="pt-2" style="color: #fff;">
                <strong>CONNECT WITH US</strong>
              </p>
            </div>
            <div class="col-auto col-12">
              <!-- Facebook -->
              <a mdbRipple target="_blank" class="btn btn-outline-light btn-floating m-1"
                href="https://www.facebook.com/tinytoys/" role="button"><i class="fa fa-facebook-f"></i></a>

              <!-- Twitter -->
              <a mdbRipple target="_blank" class="btn btn-outline-light btn-floating m-1"
                href="https://twitter.com/tinytoys?t=nkQ_6qJVb_0XYsSxp5mUQA&s=08" role="button"><i
                  class="fa fa-twitter"></i></a>

              <!-- Google -->
              <!-- <a mdbRipple class="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i
                  class="fa fa-google"></i></a> -->

              <!-- Instagram -->
              <a mdbRipple target="_blank" class="btn btn-outline-light btn-floating m-1"
                href="https://www.instagram.com/invites/contact/?i=tv2s35852q26&utm_content=n6ceenp" role="button"><i
                  class="fa fa-instagram"></i></a>

              <!-- Linkedin -->
              <a mdbRipple target="_blank" class="btn btn-outline-light btn-floating m-1"
                href="https://www.linkedin.com/tiny-toys/" role="button"><i class="fa fa-linkedin"></i></a>
            </div>
          </div>
        </section>
        <!-- Section: Social media -->
      </div>
      <div class="col-sm">
        <section>
          <form action="">
            <!--Grid row-->
            <div class="row d-flex justify-content-center">
              <!--Grid column-->
              <div class="col-auto">
                <p class="pt-2" style="color: #fff; margin: 0%;">
                  <strong>SUBSCRIBE TO OUR NEWSLATER</strong>
                </p>
              </div>
              <!--Grid column-->

              <!--Grid column-->
              <div class="col-auto col-12 d-flex justify-content-center">
                <!-- Email input -->
                <form class="form-inline form-white m-2">
                  <div class="form-group">
                    <input type="email" id="newsLaterEmail" class="form-control" placeholder="Email address" />
                  </div>
                  <div class="form-group">
                    <button type="submit" class="btn btn-outline-light ml-2">
                      Subscribe
                    </button>
                  </div>
                </form>

              </div>
            </div>
            <!--Grid row-->
          </form>
        </section>
      </div>
    </div>
  </div>
  <!-- Copyright -->
  <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
    © 2022 Copyright:
    <a class="text-white" href="https://spontaneous-pastelito-7bb697.netlify.app/">TinyToys</a>
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->
